import {
  useTheme
} from "./chunk-JVDTBYWX.js";
import {
  textareaTheme
} from "./chunk-APTGGM6D.js";

// src/components/textarea.tsx
import * as React from "react";
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
function TextareaRoot({
  color,
  size,
  resize,
  isError,
  isSuccess,
  className,
  ...props
}, ref) {
  const contextTheme = useTheme();
  const theme = contextTheme?.textarea ?? textareaTheme;
  const defaultProps = theme?.defaultProps;
  size ??= defaultProps?.size ?? "md";
  color ??= defaultProps?.color ?? "primary";
  resize ??= defaultProps?.resize ?? false;
  isError ??= defaultProps?.isError ?? false;
  isSuccess ??= defaultProps?.isSuccess ?? false;
  const styles = twMerge(
    theme.baseStyle,
    theme.color[color],
    theme.size[size],
    resize && theme["resize"],
    isError && theme["isError"],
    isSuccess && theme["isSuccess"],
    className
  );
  return /* @__PURE__ */ jsx(
    "textarea",
    {
      rows: 8,
      ...props,
      ref,
      className: styles,
      "data-error": isError,
      "data-success": isSuccess
    }
  );
}
TextareaRoot.displayName = "MaterialTailwind.Textarea";
var Textarea = React.forwardRef(TextareaRoot);
var textarea_default = Textarea;

export {
  Textarea,
  textarea_default
};
